module.exports = __webpack_public_path__ + "assets/e988c9a3555b0ac247517052666b48d9.png";